import Dbfunctions from "../PouchDb/Pouchdb";
import store from '../store';
let filteredData;
export const funcGetPartnerData = async (partner,milestone,event) => {
    let obj = await Dbfunctions.GetState("PARTNER_DATA");
    const funcGetfilteredData = () => {
        let partnerName;
        if (obj) {
            partnerName = obj.partnerEvents?.partner.filter((ele) => ele.partnerName === partner)
            if (partnerName) {
                filteredData = partnerName[0]?.milestones.filter((object) => object.journeyName === milestone)
            }
        }
        return funcGetpartnerRedirection(filteredData, event, partner);
    }
    return funcGetfilteredData();
}

const funcGetpartnerRedirection = (filteredData, event, partner) => {
    let redirectUrl;
    let env = window.global.config?.REACT_APP_ENV==="DEV" ? filteredData[0]?.staging : filteredData[0]?.prod;
    if (event === "failure") {  
        redirectUrl = env.failureURL;
    }
    else if (event === "success") {
        redirectUrl = env.successURL;
    }
    if (partner === "phonepe") {
        redirectUrl = replaceApplicationNo(redirectUrl);
    }
    return redirectUrl;
}

const replaceApplicationNo = (redirectUrl) => {
    const state = store.getState();
    return redirectUrl.replace("{applicationnumber}", state.SSL?.ckycData?.applicationNumber);
};

export const getPartnerName = () => {
    return localStorage.getItem("partnerRedirect");
}

export const isPartnerChannelCode = (channelCode) => {
    if (window.global.config?.PARTNER_CHANNEL_CODES) {
        return window.global.config.PARTNER_CHANNEL_CODES.indexOf(channelCode) !== -1;
    }
}

export const isBillDeskChannelCode = (channelCode) => {
    if (window.global.config?.BILLDESK_CHANNEL_CODES) {
        return window.global.config.BILLDESK_CHANNEL_CODES.indexOf(channelCode) !== -1;
    }
}
export const isBillDeskLeadSource = (leadSource) => {
    if (window.global.config?.BILLDESK_LEAD_SOURCE) {
        return window.global.config.BILLDESK_LEAD_SOURCE.indexOf(leadSource) !== -1;
    }
}
export const isNonbankaPartnerChannelCode = (channelCode) => {
    if (window.global.config?.NONBANKA_PARTNER_CHANNEL_CODES) {
        return window.global.config.NONBANKA_PARTNER_CHANNEL_CODES.indexOf(channelCode) !== -1;
    }
}
export const isNonbankaPartner = (partner) => {
    if (window.global.config?.NONBANKA_PARTNERS) {
        return window.global.config.NONBANKA_PARTNERS.indexOf(partner) !== -1;
    }
}
export const isPartnerLeadSource = (leadSource) => {
    if (window.global.config?.Partners_LeadSource) {
        return window.global.config.Partners_LeadSource.indexOf(leadSource) !== -1;
    }
}

export const partnerRedirectUrlVal = (leadSource) => {
    let partnerRedirection = window.global?.config?.Partners_LeadSource.filter(item =>(item.leadSource === leadSource ))
    return partnerRedirection[0].partnerRedirect;
}

export const getPartnerAddress = (partnerData) => {
    if (partnerData && partnerData != null) {
        let partnerResiAddr = {
            houseNo: partnerData?.resiAddressLine1,
            locality: "",
            resiAddressLine2: partnerData?.resiAddressLine2,
            landmark: "",
            pin: partnerData?.resiPinCode,
            state: partnerData?.resiState,
            city: partnerData?.resiCity,
            addressType: partnerData?.addressType
        };

        return partnerResiAddr;
    }
}